import { render, staticRenderFns } from "./DeleteTransferReason.vue?vue&type=template&id=6a0a55d4"
import script from "./DeleteTransferReason.vue?vue&type=script&lang=js"
export * from "./DeleteTransferReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports